import { render, staticRenderFns } from "./ZhuSu.vue?vue&type=template&id=ac1ec9d6&scoped=true"
import script from "./ZhuSu.vue?vue&type=script&lang=js"
export * from "./ZhuSu.vue?vue&type=script&lang=js"
import style0 from "./ZhuSu.vue?vue&type=style&index=0&id=ac1ec9d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1ec9d6",
  null
  
)

export default component.exports